/* ImageWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ImageWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
var imageWrapperStyles = null;
var dynamicImageWrapperStyles = null;
export var ImageWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    isHidden = _ref.isHidden;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "media-viewer-svg-wrapper",
    onClick: onClick,
    ref: ref,
    className: ax(["_1reo1wug _18m91wug _1bsbauwl _4t3i1kxc _y3gn1h6o _s7n4nkob _o5721q9c", isHidden && "_1reo15vq _18m915vq"])
  }, children);
});